import { createFileRoute } from '@tanstack/react-router';

import ErrorPage from 'pages/errorPage/errorPage.component';

export const Route = createFileRoute('/404')({
  component: ErrorPage,
});
